import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'sre-dashboard',
});

export const governanceRouteRef = createSubRouteRef({
  id: 'sre-dashboard:governance',
  parent: rootRouteRef,
  path: '/governance',
});

export const resourcesRouteRef = createSubRouteRef({
  id: 'sre-dashboard:resources',
  parent: rootRouteRef,
  path: '/resources',
});

export const decisionsRouteRef = createSubRouteRef({
  id: 'sre-dashboard:decisions',
  parent: rootRouteRef,
  path: '/decisions',
});
